<template>
  <div class="detail_box">
    <div class="detail_info" v-html="liveInfo.introductionHtml"></div>
  </div>
</template>
<script>
import { deepClone } from "@/utils";
export default {
  name: "Detail",
  props: {
    detail: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      liveInfo: null,
    };
  },
  watch: {
    detail: {
      handler(newValue, oldValue) {
        this.liveInfo = deepClone(newValue);
      },
      deep: true,
    },
  },
  methods: {},
  created() {
    this.liveInfo = deepClone(this.detail);
  },
};
</script>
<style scoped lang="scss">
.detail_box {
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  .detail_info {
    padding: 10px 15px;
    /deep/p {
      line-height: 24px;
      text-indent: 2em;
      margin-bottom: 10px;
      text-align: justify;
    }
    /deep/img {
      display: block;
      max-width: 100%;
      margin: auto;
    }
    /deep/video {
      display: block;
      max-width: 100%;
      margin: auto;
    }
  }
}
</style>